export default "__VITE_ASSET__DoN8mFPs__"